import React, { useEffect, useMemo, useState } from 'react';
import { CheckOutlined, SolutionOutlined, UserAddOutlined } from '@ant-design/icons';
import { Button, Card, Drawer, Empty, Flex, Input, List, Space, Typography } from 'antd';
import { toSearchText } from 'utils/text';

const { Text, Title } = Typography;

const CustomerPickerMobile = ({ viewModel }) => {
  const {
    value,
    onChange,
    placeholder,
    selectProps,
    options,
    loading,
    selectedCustomer,
    setShowAddCustomer,
    setShowCustomerInfo,
  } = viewModel;

  const [open, setOpen] = useState(false);
  const [keywordInput, setKeywordInput] = useState('');
  const [keyword, setKeyword] = useState('');
  const [draftValue, setDraftValue] = useState(value ?? null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setKeyword(keywordInput);
    }, 200);

    return () => clearTimeout(timeout);
  }, [keywordInput]);

  useEffect(() => {
    setDraftValue(value ?? null);
  }, [value]);

  const filteredOptions = useMemo(() => {
    const normalizedKeyword = toSearchText(keyword.trim());

    if (!normalizedKeyword) {
      return options;
    }

    return (options || []).filter((item) => {
      const optionSearchText = item.searchText || toSearchText(String(item.label || ''));
      return optionSearchText.includes(normalizedKeyword);
    });
  }, [keyword, options]);

  const selectedLabel = selectedCustomer
    ? `${selectedCustomer.phone || ''} ${selectedCustomer.full_name || ''}`.trim()
    : placeholder;

  const onOpen = () => {
    setDraftValue(value ?? null);
    setKeyword('');
    setKeywordInput('');
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setKeyword('');
    setKeywordInput('');
  };

  const onApply = () => {
    onChange?.(draftValue);
    onClose();
  };

  return (
    <>
      <Flex gap={8}>
        <Button
          block
          onClick={onOpen}
          disabled={selectProps.disabled}
          loading={loading}
          style={{ textAlign: 'left', overflow: 'hidden' }}
        >
          <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {selectedLabel}
          </span>
        </Button>

        {value && (
          <Button onClick={() => setShowCustomerInfo(true)} icon={<SolutionOutlined />} />
        )}
      </Flex>

      <Drawer
        title={placeholder}
        placement='bottom'
        open={open}
        onClose={onClose}
        height='80vh'
        styles={{ body: { paddingBottom: 'calc(16px + env(safe-area-inset-bottom, 0px))' } }}
      >
        <Space direction='vertical' size={12} style={{ width: '100%' }}>
          <Card size='small' styles={{ body: { padding: 12 } }}>
            <Space direction='vertical' size={10} style={{ width: '100%' }}>
              {selectedCustomer && (
                <div>
                  <Text type='secondary'>Đang chọn</Text>
                  <Title level={5} style={{ margin: 0 }}>
                    {selectedCustomer.full_name || selectedLabel}
                  </Title>
                  {selectedCustomer.phone && <Text type='secondary'>{selectedCustomer.phone}</Text>}
                </div>
              )}

              <Input
                value={keywordInput}
                onChange={(event) => setKeywordInput(event.target.value)}
                placeholder='Tìm khách hàng'
                allowClear
              />
            </Space>
          </Card>

          <div style={{ width: '100%', maxHeight: '50vh', overflowY: 'auto' }}>
            <List
              dataSource={filteredOptions}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description='Không tìm thấy khách hàng phù hợp'
                  >
                 
                  </Empty>
                ),
              }}
              renderItem={(item) => (
                <List.Item
                  key={item.value}
                  onClick={() => setDraftValue(item.value)}
                  style={{ cursor: 'pointer', padding: '10px 4px' }}
                >
                  <Flex
                    align='center'
                    justify='space-between'
                    gap={12}
                    style={{
                      width: '100%',
                      padding: '8px 6px',
                      borderRadius: 10,
                      background: draftValue === item.value ? '#f0f7ff' : 'transparent',
                    }}
                  >
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <Text style={{ display: 'block' }} ellipsis={{ tooltip: item.customer?.full_name || item.label }}>
                        {item.customer?.full_name || item.label}
                      </Text>
                      {item.customer?.phone && (
                        <Text type='secondary'>{item.customer.phone}</Text>
                      )}
                    </div>
                    {draftValue === item.value ? <CheckOutlined style={{ color: '#1677ff' }} /> : <span style={{ width: 14 }} />}
                  </Flex>
                </List.Item>
              )}
            />
          </div>

          <Flex gap={8}>
            <Button block onClick={() => setShowAddCustomer(true)}>
              <UserAddOutlined />
            </Button>
            <Button block onClick={() => setDraftValue(undefined)} disabled={!draftValue}>
              Xoá 2
            </Button>
            <Button type='primary' block onClick={onApply}>
              Xong
            </Button>
          </Flex>
        </Space>
      </Drawer>
    </>
  );
};

export default CustomerPickerMobile;